// /c/{code} — 面板「請用手機確認」QR 的網址（docs/panel/10-phone-auth-scenes.md §2.3、M4）。
// 家人手機有裝親疼 App 時由 App Link / Universal Link 直接開進 App；**沒裝（或連結沒接上）才會被瀏覽器打開這一頁**。
// 網頁不做手機確認（M4）：這一頁只用白話說明「請用親疼 App 掃描」+ 下載入口；碼不送雲端、不認領，
// 一進來就把網址換成 /c（碼不留在瀏覽紀錄），下載連結 noreferrer（碼不會被帶去別的網站）。不用登入。
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './confirm.css';

/** 下載入口：建置時給（VITE_LOOP_APP_DOWNLOAD_URL）；只收 https，沒設就只寫「請家人幫你安裝」 */
export function appDownloadUrl(raw: string | undefined = import.meta.env.VITE_LOOP_APP_DOWNLOAD_URL): string | null {
  const u = (raw ?? '').trim();
  if (!u) return null;
  try {
    return new URL(u).protocol === 'https:' ? u : null;
  } catch {
    return null;
  }
}

export default function PanelConfirmLandingPage() {
  const { t } = useTranslation();
  useEffect(() => {
    try {
      if (/^\/c\/./.test(window.location.pathname)) window.history.replaceState(window.history.state, '', '/c');
    } catch {
      /* 換不了網址也不影響說明 */
    }
  }, []);
  const dl = appDownloadUrl();
  return (
    <main className="cf-landing" data-testid="panel-confirm-landing">
      <div className="cf-landing-icon" aria-hidden="true">📱</div>
      <h1>{t('confirm.landing_title')}</h1>
      <p className="cf-landing-lead">{t('confirm.landing_lead')}</p>
      <ol className="cf-landing-steps">
        <li>
          <strong>{t('confirm.landing_have_app')}</strong>
          <span>{t('confirm.landing_have_app_steps', { hint: t('auth.phone.hint') })}</span>
        </li>
        <li>
          <strong>{t('confirm.landing_no_app')}</strong>
          {dl ? (
            <a className="btn-primary cf-landing-dl" href={dl} rel="noreferrer noopener" target="_blank" data-testid="panel-confirm-download">
              {t('confirm.landing_download')}
            </a>
          ) : (
            <span data-testid="panel-confirm-ask-family">{t('confirm.landing_ask_family')}</span>
          )}
        </li>
      </ol>
      <p className="text-secondary">{t('confirm.landing_pin_hint')}</p>
    </main>
  );
}
